module.exports = __webpack_public_path__ + "static/media/overdue-auto-followup.a88bca3b.svg";